import './style.css';
import {
  initEditores,
  preencherObjetivos,
  getObjetivosGeraisHTML,
  getObjetivosEspecificosHTML,
  getJustificativaHTML,
  getResponsabilidadesUFCHTML,
  getResponsabilidadesParceiroHTML,
  getAtividadesConjuntasHTML,
  getDireitosPIHTML
} from './editor';
import { initListaAtividades, preencherAtividades, syncProgressoAtividades, getAtividades } from './activities';
import { initIdentificacao, preencherIdentificacao } from './partners';
import { initObjetoProjeto, preencherObjetoProjeto, getObjetoProjeto } from './object';
import { handleGerarDocumento } from './api';
import { carregarRascunho } from './db';
import {
  atualizarChecklistCaracterizacao,
  atualizarChecklistObjeto,
  atualizarChecklistJustificativa,
  atualizarChecklistDescAtividades,
  atualizarChecklistDireitosPI,
  atualizarChecklistAtividades
} from './progress';
import { initOrcamento } from './budget';
import { atualizarChecklistPlanoFinanceiro } from './progress';
import { initMeiosLista, preencherMeios, preencherMeiosUfc, syncProgressoMeios } from './meios';
import { initLastEditFromStorage, setLastEditNow } from './lastedit';
import { initPrefillActions } from './features/prefill-actions';
import { initHelpSections } from './features/help-sections';
import { initAssistantPanel } from './features/assistant-panel';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPrefillActions());
} else {
  initPrefillActions();
}

async function bootstrap() {
  // 1) Inicializações
  console.log("Inicializando as seções de ajuda e painel da IA...");  
  initHelpSections();
  initAssistantPanel();  
  initEditores();
  initListaAtividades();
  initIdentificacao();
  initObjetoProjeto();
  initOrcamento();
  initLastEditFromStorage();


  // 2) Hidrata rascunho se existir
  const draft = await carregarRascunho();
  if (draft) {
    preencherIdentificacao(draft);
    preencherObjetoProjeto(draft);
    preencherObjetivos(Promise.resolve(draft));
    if (draft.atividades) preencherAtividades(draft.atividades);
  }

  // 3) Atualiza checklists iniciais
  const obj = getObjetoProjeto();
  atualizarChecklistObjeto(obj.tituloProjeto, obj.tipoProjeto, obj.areaConhecimento);
  atualizarChecklistCaracterizacao(getObjetivosGeraisHTML(), getObjetivosEspecificosHTML());
  atualizarChecklistJustificativa(getJustificativaHTML());
  atualizarChecklistDescAtividades(
    getResponsabilidadesUFCHTML(),
    getResponsabilidadesParceiroHTML(),
    getAtividadesConjuntasHTML()
  );
  atualizarChecklistDireitosPI(getDireitosPIHTML());
  atualizarChecklistAtividades(getAtividades().length > 0);
  initMeiosLista();
  preencherMeios(draft?.meios ?? []);
  preencherMeiosUfc((draft as any)?.meiosUfc ?? []);
  void syncProgressoMeios();

  const hasFinanceItems =
    !!(
      draft?.tabelas_orcamento?.some((t) => (t.itens?.length ?? 0) > 0) ||
      (draft?.orcamento?.length ?? 0) > 0
    );

  atualizarChecklistPlanoFinanceiro(hasFinanceItems);

  setTimeout(() => {
    syncProgressoAtividades();
  }, 0);

  const container = document.querySelector('.app-container') || document.body;
  container.addEventListener('input', (e) => {
    const t = e.target as HTMLElement | null;
    if (!t) return;
    if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement) {
      setLastEditNow();
    }
  });
  container.addEventListener('change', (e) => {
    const t = e.target as HTMLElement | null;
    if (!t) return;
    if (t instanceof HTMLSelectElement) {
      setLastEditNow();
    }
  });

  const btnRevisar = document.getElementById('btn-revisor');
  if (btnRevisar) {
    btnRevisar.addEventListener('click', () => {
      revisorProjetos();
    });
  }
  document.getElementById('gerar-doc')?.addEventListener('click', () => {
    void handleGerarDocumento();
  });
}

function revisorProjetos(): void {
  if (import.meta.env.DEV) {
    window.location.href = '/revisor/';
  } else {
    window.location.href = '/assis/revisor/';
  }
}

window.addEventListener('DOMContentLoaded', () => { void bootstrap(); });